import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginModalPageModule } from './login-modal/login-modal.module';
import { WebviewpagesPageModule } from './webviewpages/webviewpages.module';
import { BetHistoryModule } from './bet-history/bet-history.module';
import { BookBetPageModule } from './book-bet/book-bet.module';
import { TranslateModule } from '@ngx-translate/core';
import { CheckBetComponent } from './check-bet/check-bet';
import { FastBetComponent } from './fast-bet/fast-bet';
import { SiteMaintenancePageModule } from './site-maintenance/site-maintenance.module';
import { FreeBetComponent } from './free-bet/free-bet';
import { BalanceModalPageModule } from './balance-modal/balance-modal.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { RegisterModalPageModule } from './register-modal/register-modal.module';
import { ForgotPasswordModalPageModule } from './forgot-password-modal/forgot-password-modal.module';
import { LoaderComponent } from './loader/loader';
import { LoaderTwoComponent } from './loader-two/loader-two';
import { GreyPageModule } from './grey/grey.module';
import { BaselineSharedModule } from 'baseline-lib';
import { ThirdpartywebpopupPageModule } from './thirdpartywebpopup/thirdpartywebpopup.module';



@NgModule({
  declarations: [
    CheckBetComponent,
    FastBetComponent,
    FreeBetComponent,
    LoaderComponent,
    LoaderTwoComponent
  ],
  imports: [
    LoginModalPageModule,
    BalanceModalPageModule,
    WebviewpagesPageModule,
    BetHistoryModule,
    BookBetPageModule,
    SiteMaintenancePageModule,
    IonicPageModule.forChild(SharedModule),
    TranslateModule,
    LazyLoadImageModule,
    RegisterModalPageModule,
    GreyPageModule,
    ForgotPasswordModalPageModule,
    BaselineSharedModule,
    ThirdpartywebpopupPageModule

  ],
  exports: [
    LoginModalPageModule,
    BookBetPageModule,
    BalanceModalPageModule,
    WebviewpagesPageModule,
    BetHistoryModule,
    CheckBetComponent,
    FastBetComponent,
    FreeBetComponent,
    SiteMaintenancePageModule,
    TranslateModule,
    LoaderComponent,
    LoaderTwoComponent,
    GreyPageModule,
    RegisterModalPageModule
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts